import React, {useEffect, useState} from "react";
import axiosInstance from "../../api";
import Spinner from "../../components/Spinner";
import {Box, Checkbox, Grid, Snackbar, Typography, MenuItem} from "@material-ui/core";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Button, Link, Pagination} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import {Alert} from "@material-ui/lab";
import {MUIAutoComplete, MUICardWithControl, MUISelect, MUIConfirmationDialog, MUIInput, MUIDatePicker} from "../../utils/formUtils";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import addressData from "../../data/addressData.json";
import LeadStatusUpdatePage from "./LeadStatusUpdatePage";
import {currencyFormat, downloadFile} from "../../utils/fmapUtils";
import {format} from "date-fns";
import {useUserContext} from "../../context/UserContext";
import add from "date-fns/add/index.js"

const validationSchema = yup.object().shape({
    zip: yup.number().transform((currentValue, originalValue) => {
        return originalValue === '' ? null : currentValue;
    }).nullable().typeError("Enter valid number."),
    amount: yup.number().transform((currentValue, originalValue) => {
        return originalValue === '' ? null : currentValue;
    }).nullable().typeError("Enter valid number."),
    year: yup.number().transform((currentValue, originalValue) => {
        return originalValue === '' ? null : currentValue;
    }).nullable().typeError("Enter valid number."),
    leadTaggedOn: yup.date().min(add(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), {days: -30}), "No Prior Date Allowed.")
                            .max(add(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), {days: 1}), "No Future Date Allowed.")
                            .nullable().typeError(),
    needBy: yup.date().min(add(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), {days: -30}), "No Prior Date Allowed.")
                            .nullable().typeError(),
    expirationDate: yup.date().min(add(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), {days: -30}), "No Prior Date Allowed.")
                            .nullable().typeError()
});
const initSearch = {"zip": '', "county": '', 'needBy': null, 'amount':'', 'propertyType':'', 'constructionType':'',
                     'year':'', 'leadTaggedOn': null, 'expirationDate': null, 'searchName':''};
const label = {inputProps: {'aria-label': 'Checkbox'}};
const _EXCELHEADERS = ["Property Address","County", "Consumer Details", "Need By", "Amount of property coverage desired", "Insurance Reason", "Property Usage", "Property Type", "Construction Type", "Year Built", "Year for updates on roof", "Year for updates on electrical", "Year for updates on plumbing", "Approximate livable square footage", "No of claims", "Do you have a pool?", "Is the property located within 1000 ft. of a fire hydrant?", "Is the property located within 5 miles of manned fire station?", "How close is this property to salt water (ocean, intracoastal)", "Is any business or farming conducted onsite?", "Search Name"];
export default function AgentTaggedLeadsListView({agentId,user}) {
    const [matchingLeads, setMatchingLeads] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [searchCriteria, setSearchCriteria] = useState({});
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [filterCriteria, setFilterCriteria] = useState(initSearch);
    const [showFilter, setShowFilter] = useState(false);
    const [countyList, setCountyList] = useState([]);
    const {handleSubmit, control, reset, formState: {errors}} = useForm({resolver: yupResolver(validationSchema)});
    const [filterValue, setFilterValue] = useState('** no filters **');
    const [showLeadUpdatePage, setShowLeadUpdatePage] = useState(false);
    const [leadAgentId, setLeadAgentId] = useState(null);
    const [quoteStatus, setQuoteStatus] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [snackBarSettings, setSnackBarSettings] = useState({show: false, message: null, variant: 'success'});
    const [yearSpanList, setYearSpanList] = useState([]);
    const [disToCoastList, setDisToCoastList] = useState([]);
    //const {user,dispatch} = useUserContext();
    //const {consumerData, dispatch} = useConsumerContext();
    const [propertyTypeList, setPropertyTypeList] = useState([]);
    const [constructionTypeList, setConstructionTypeList] = useState([]);


    useEffect(() => {
        setPropertyTypeList(addressData.propertyType);
        setConstructionTypeList(addressData.constructionType);
        setCountyList(addressData.county);
        setYearSpanList(addressData.yearSpanConsumer);
        setDisToCoastList(addressData.distanceToCoast);

        getMatchingLeads({agentId: agentId, quoteStatus: 'TAGGED'});
    }, []);

    useEffect(() => {
        let currentFilteredValue = '';
        if (filterCriteria.zip) {
            currentFilteredValue = 'Zip : ' + filterCriteria.zip;
        }

        if (filterCriteria.county) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'County : ' + filterCriteria.county;
        }

        if (filterCriteria.needBy) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'needBy : ' + format(filterCriteria.needBy, 'MM/dd/yyyy');
        }

        if (filterCriteria.amount) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'amount : ' + filterCriteria.amount;
        }

        if (filterCriteria.propertyType) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'propertyType : ' + filterCriteria.propertyType;
        }

        if (filterCriteria.constructionType) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'constructionType : ' + filterCriteria.constructionType;
        }

        if (filterCriteria.year) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'year : ' + filterCriteria.year;
        }

        if (filterCriteria.leadTaggedOn) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'leadTaggedOn : ' + format(filterCriteria.leadTaggedOn, 'MM/dd/yyyy');
        }

        if (filterCriteria.expirationDate) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'expirationDate : ' + format(filterCriteria.expirationDate, 'MM/dd/yyyy');
        }

        if (filterCriteria.searchName) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'searchName : ' + filterCriteria.searchName;
        }

        if (!filterCriteria.zip && !filterCriteria.county && !filterCriteria.needBy && !filterCriteria.amount
             && !filterCriteria.propertyType && !filterCriteria.constructionType && !filterCriteria.year && !filterCriteria.leadTaggedOn && !filterCriteria.expirationDate && !filterCriteria.searchName) {
            currentFilteredValue = '** no filters **';
        }
        setFilterValue(currentFilteredValue);
    }, [searchCriteria]);

    const getMatchingLeads = (payload) => {
        setShowSpinner(true);
        axiosInstance.post("lead-agent/get-lead-agent-map-critieria", payload)
            .then((data) => {
                setErrorMessage(null);
                setSearchCriteria(Object.assign({}, data.searchCriteria));
                if (data.totalResultSetSize && !isNaN(data.totalResultSetSize) && !isNaN(data.searchCriteria.numberOfRecordsPerPage)) {
                    setPageCount(Math.ceil(data.totalResultSetSize / data.searchCriteria.numberOfRecordsPerPage));
                }
                if (data && data.resultList && data.resultList.length > 0) {
                    setMatchingLeads([...data.resultList]);
                } else {
                    setMatchingLeads([]);
                    setPageCount(0)
                }
            })
            .catch((error) => setErrorMessage('An error occured while retrieving your records'))
            .finally(() => setShowSpinner(false));
    }

    const getRecordsByPageNumber = (pageNumber) => {
        if (searchCriteria) {
            let criteriaWithPageNumber = Object.assign({}, searchCriteria, {pageToShow: pageNumber});
            setSearchCriteria(criteriaWithPageNumber);
            getMatchingLeads(criteriaWithPageNumber);
        }
    }

    const onPageChange = (event, pageNumber) => {
        setSelectedRows([]);
        setCurrentPage(pageNumber);
        getRecordsByPageNumber(pageNumber);
    }

    const handleFormChange = (event) => {
        setFilterCriteria(Object.assign({}, filterCriteria, {[event.target.name]: event.target.value}));
    };

    const onSubmit = data => {
        setCurrentPage(1);
        let filterCritera = data;
        filterCritera.agentId = agentId;
        filterCritera.quoteStatus = 'TAGGED';
        getMatchingLeads(filterCritera)
    };

    const handleRecordView = (leadAgentId, quoteStatus) => {
        setShowLeadUpdatePage(true);
        setLeadAgentId(leadAgentId);
        setQuoteStatus(quoteStatus);
    };

    const onReturnBack = () => {
        getMatchingLeads(searchCriteria);
        setShowLeadUpdatePage(false);
    }

    const handleCheckboxDownload = (checked, leadAgentMapId) => {
        if (checked) {
            if (!selectedRows.includes(leadAgentMapId)) {
                setSelectedRows([...selectedRows, leadAgentMapId]);
            }
        } else {
            let updList = selectedRows.filter(x => x !== leadAgentMapId);
            setSelectedRows([...updList]);
        }
    };

    const handleBooleans = (val) => {
        return (!!val) ? "YES" : "NO";
    }

    const getYearLabel = (value) => {
        return (yearSpanList && yearSpanList.length > 0 ) ? yearSpanList?.filter(x => x.value === Number(value))[0]?.label : '';
    };

    const handleFileDownload = (event) => {
        event.preventDefault();
        if (selectedRows.length === 0) {
            setSnackBarSettings({show: true, message: 'Select the data to download.', variant: 'error'});
            return;
        }
        setShowSpinner(true);
        let fileContents = [];
        let row = []
        fileContents.push(_EXCELHEADERS);
        selectedRows?.forEach(x => {
            let matchingRow = matchingLeads?.filter(y => y.leadAgentMapId === x)[0];
            row = [matchingRow?.leadAddressLabel,matchingRow?.leadAddress?.county, matchingRow?.leadContactLabel, format(new Date(matchingRow.needByDateLabel), 'MM/dd/yyyy'),
                currencyFormat(matchingRow?.amountLabel),
                matchingRow?.leadRequest?.insuranceReasonLabel,
                matchingRow?.leadRequest?.propertyUsageLabel,
                matchingRow?.propertyTypeLabel,
                matchingRow?.constructionTypeLabel,
                matchingRow?.yearBuiltLabel,
                getYearLabel(matchingRow?.leadRequest?.roof),
                getYearLabel(matchingRow?.leadRequest?.electrical),
                getYearLabel(matchingRow?.leadRequest?.plumbing),
                matchingRow?.leadRequest?.squareFootage,
                matchingRow?.leadRequest?.numOfClaims,
                handleBooleans(matchingRow?.leadRequest?.hasOnsitePool),
                handleBooleans(matchingRow?.leadRequest?.isLocated1000ftFireHydrant),
                handleBooleans(matchingRow?.leadRequest?.is5miFromMannedFireStation),
                disToCoastList.filter(i => i.value == matchingRow?.leadRequest?.milesFromSaltWater)[0]?.label,
                handleBooleans(matchingRow?.leadRequest?.isBusinessLocation),
                matchingRow?.searchNames];
            fileContents.push(row);
        })
        downloadFile(fileContents, 'FMAP_Tagged_Export_' + Date.now().toString() + '.csv')
        setShowSpinner(false);
    };

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarSettings({show: false, message: null, variant: ''});
    };

    const handleAllCheck = (checked) => {
        if (checked) {
            setSelectedRows(matchingLeads.map(x => x.leadAgentMapId));
        } else {
            setSelectedRows([]);
        }
    }
    const handleExpirationDateRange = (expiryDate) => {
        setFilterCriteria(Object.assign({}, filterCriteria, {'expirationDate': expiryDate}));
    }

    const handleNeedByRange = (needByDate) => {
        setFilterCriteria(Object.assign({}, filterCriteria, {'needBy': needByDate}));
    }

    const handleLeadTaggedOnRange = (taggedOnDate) => {
        setFilterCriteria(Object.assign({}, filterCriteria, {'leadTaggedOn': taggedOnDate}));
    }

    if (showSpinner) return <Spinner/>

    return (
        <>
            {!showLeadUpdatePage && <Box m={2}>
                <Typography variant="h4" align="left" component="h4" gutterBottom
                            style={{paddingLeft: 4, fontWeight: 600}}>
                    Tagged Leads
                </Typography>

                <Typography style={{paddingLeft: 4, marginBottom: 4}}>
                    Filter Leads {!showFilter && <span>&nbsp;&nbsp;<b>{filterValue}</b>&nbsp;</span>} {!showFilter &&
                <Link href="#"  onClick={() => setShowFilter(!showFilter)}>(show filters)</Link>} {showFilter &&
                <Link href="#"  onClick={() => setShowFilter(!showFilter)}>(hide filters)</Link>} <Link href="#"  onClick={() => {
                    setFilterCriteria(Object.assign({}, filterCriteria, {zip: '', county: '', needBy: null, amount:'' , propertyType: '', constructionType: '',
                                                                        year: '', leadTaggedOn: null, expirationDate: null,searchName: ''}));
                    reset();
                    setFilterValue('** no filters **');
                    setCurrentPage(1);
                }}>(clear filters)</Link>
                </Typography>
                {showFilter &&
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container alignItems="flex-start" spacing={2} style={{marginBottom: 3}}>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="zip" defaultValue={filterCriteria?.zip}
                                      inputPrp={{maxLength: 5}}
                                      value={filterCriteria?.zip} label="ZIP"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIAutoComplete id="county" control={control} name="county" label="County"
                                             errors={errors}
                                             value={filterCriteria?.county} onValueChange={handleFormChange}
                                             options={countyList}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MUIDatePicker    name="needBy" control={control}
                                            label="Need By"
                                            minDateMessage=""
                                            dateValue={filterCriteria?.needBy}
                                            handleDateChange={handleNeedByRange}
                                            errors={errors}></MUIDatePicker>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="amount" defaultValue={filterCriteria?.amount}
                                      inputPrp={{maxLength: 8}}
                                      value={filterCriteria?.amount} label="Amount"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUISelect id="propertyType" control={control} name="propertyType" label="Property Type"
                                    errors={errors}
                                    defaultValue={filterCriteria?.propertyType}
                                    value={filterCriteria?.propertyType} onFormChange={handleFormChange}>
                                <MenuItem key="none" value="" >--Select--</MenuItem>
                                {propertyTypeList.map(type => {
                                    return <MenuItem key={type?.value} value={type?.value}>{type?.label}</MenuItem>
                                })}
                            </MUISelect>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUISelect id="constructionType" control={control} name="constructionType" label="Construction Type"
                                           errors={errors}
                                           defaultValue={filterCriteria?.constructionType}
                                           value={filterCriteria?.constructionType} onFormChange={handleFormChange}>
                                    <MenuItem key="none" value="" >--Select--</MenuItem>
                                    {constructionTypeList.map(type => {
                                        return <MenuItem key={type?.value} value={type?.value}>{type?.label}</MenuItem>
                                    })}
                                </MUISelect>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="year" defaultValue={filterCriteria?.year}
                                      inputPrp={{maxLength: 4}}
                                      value={filterCriteria?.year} label="Year"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIDatePicker  name="leadTaggedOn" control={control}
                                            label="Lead Tagged On"
                                            minDateMessage=""
                                            dateValue={filterCriteria?.leadTaggedOn}
                                            handleDateChange={handleLeadTaggedOnRange}
                                            errors={errors}></MUIDatePicker>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIDatePicker name="expirationDate" control={control}
                                           label="Expiration Date"
                                           minDateMessage=""
                                           dateValue={filterCriteria?.expirationDate}
                                           handleDateChange={handleExpirationDateRange}
                                           errors={errors}></MUIDatePicker>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="searchName" defaultValue={filterCriteria?.searchName}
                                      inputPrp={{maxLength: 20}}
                                      value={filterCriteria?.searchName} label="Search Name"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button type="submit">Search</Button>
                        </Grid>
                    </Grid>
                </form>
                }

                {matchingLeads.length === 0 && <><Box component="span" display="flex"
                                                      style={{backgroundColor: "lightblue", marginBottom: 5}} p={2}>
                    No tagged leads available for your search criteria.
                </Box>
                    <br/>
                    <br/>
                </>}

                {matchingLeads.length > 0 &&
                <section>
                    <TableContainer>
                        <Table size="small" aria-label="a dense table">
                            <TableHead style={{backgroundColor: "#1c2438"}}>
                                <TableRow>
                                    <TableCell style={{color: "#ffffff"}}>
                                        <Checkbox {...label} size="small" color="info" style={{color: "white"}}
                                                  checked={matchingLeads?.length === selectedRows?.length}
                                                  onChange={(event, checked) => handleAllCheck(checked)}
                                                  labelStyle={{color: 'white'}}/>
                                    </TableCell>
                                    <TableCell style={{color: "#ffffff"}}>#</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Property Address</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>County</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Consumer Details</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Need By</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Amount</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Property Type</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Construction Type</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Year</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Lead Tagged On</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Expiration Date</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Search Name</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {matchingLeads.map((row, index) => (
                                    <TableRow
                                        key={row?.leadAgentMapId}
                                        sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                    >
                                        <TableCell component="th" scope="row">
                                            <Checkbox {...label} size="small" color="primary"
                                                      checked={selectedRows.includes(row?.leadAgentMapId)}
                                                      onChange={(event, checked) => handleCheckboxDownload(checked, row?.leadAgentMapId)}/>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {index + 1}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row?.leadAddressLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row?.leadAddress?.county}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row?.leadContactLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.needByDateLabel &&
                                            <span>{format(new Date(row.needByDateLabel), 'MM/dd/yyyy')}</span>}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {currencyFormat(row.amountLabel)}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.propertyTypeLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.constructionTypeLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.yearBuiltLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.tagStartDate && <span>{format(new Date(row.tagStartDate), 'MM/dd/yyyy')}</span>}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.tagEndDate && <span>{format(new Date(row.tagEndDate), 'MM/dd/yyyy')}</span>}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.searchNames}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            { (user.fmapRole === "FMAP_ADMIN" || user.fmapRole === "FMAP_AGENT") && <Link
                                                onClick={() => handleRecordView(row.leadAgentMapId, row.quoteStatus)}>View</Link>}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {pageCount > 1 &&
                    <Box component="span" justifyContent="center" alignItems="flex-end" display="flex">
                        <Pagination count={pageCount} color="primary" shape="rounded" onChange={onPageChange}
                                    page={currentPage}/>
                    </Box>}

                    {matchingLeads.length > 0 && <><Box component="span" display="flex">
                        <Button onClick={handleFileDownload}>Download Leads</Button>
                    </Box>
                        <br/>
                        <br/>
                    </>}
                </section>
                }
                <br/>
                {errorMessage && <Box>
                    <div>
                        <br/>
                        <Alert variant="filled" severity="error">{errorMessage}</Alert>
                    </div>
                </Box>}
                <br/>
            </Box>}
            {showLeadUpdatePage && <Box m={2}>
                <LeadStatusUpdatePage agentId={agentId} leadAgentId={leadAgentId}
                                      setShowLeadUpdatePage={setShowLeadUpdatePage} quoteStatus={quoteStatus}
                                      onReturnBack={onReturnBack}/>
            </Box>}
            <Snackbar open={snackBarSettings.show} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose}
                       severity={snackBarSettings.variant}>{snackBarSettings.message}</Alert>
            </Snackbar>
        </>
    );
}
